// public/js/features/assets/batch-import-handler.js
export function setupBatchImport() {
    const toggleBtn = document.getElementById('btn-batch-import-toggle');
    const batchSection = document.getElementById('batch-import-section');
    const textarea = document.getElementById('batch-json-input');
    const statusDiv = document.getElementById('batch-status');
    const createBtn = document.getElementById('btn-create-asset');
    const batchCreateBtn = document.getElementById('btn-batch-create');
    const progressContainer = document.getElementById('batch-progress-container');
    const progressBar = document.getElementById('batch-progress-bar');
    const closeBatchBtn = document.getElementById('btn-close-batch');
  
    if (!toggleBtn || !batchSection || !textarea) return;
  
    let parsedAssets = [];
  
    toggleBtn.addEventListener('click', () => {
      batchSection.classList.toggle('d-none');
      if (!batchSection.classList.contains('d-none')) {
        createBtn.classList.add('d-none');
        batchCreateBtn.classList.remove('d-none');
        textarea.focus();
      } else {
        createBtn.classList.remove('d-none');
        batchCreateBtn.classList.add('d-none');
      }
    });
  
    closeBatchBtn?.addEventListener('click', () => {
      batchSection.classList.add('d-none');
      createBtn.classList.remove('d-none');
      batchCreateBtn.classList.add('d-none');
      statusDiv.innerHTML = '';
      progressContainer.classList.add('d-none');
      textarea.value = '';
      parsedAssets = [];
    });
  
    textarea.addEventListener('input', () => {
      statusDiv.innerHTML = '';
      parsedAssets = [];
      batchCreateBtn.disabled = true;
  
      const val = textarea.value.trim();
      if (!val) return;
  
      try {
        const data = JSON.parse(val);
        const assets = Array.isArray(data) ? data : [data];
        const invalid = assets.filter(a => !a.assetUUID || !a.name);
        if (invalid.length > 0) {
          statusDiv.innerHTML = `<span class="text-danger">❌ ${invalid.length} entries without assetUUID or name</span>`;
          return;
        }
        parsedAssets = assets;
        statusDiv.innerHTML = `<span class="text-success">✅ ${assets.length} assets detected</span><small class="text-muted d-block mt-1">Ready to import</small>`;
        batchCreateBtn.disabled = false;
      } catch (e) {
        statusDiv.innerHTML = `<span class="text-danger">❌ Invalid JSON</span>`;
      }
    });
  
    batchCreateBtn.addEventListener('click', async () => {
      if (parsedAssets.length === 0) return;
  
      batchCreateBtn.disabled = true;
      progressContainer.classList.remove('d-none');
      progressBar.style.width = '0%';
      statusDiv.innerHTML = `<span class="text-info">Importing ${parsedAssets.length} assets...</span>`;
  
      let success = 0, failed = 0;
  
      for (let i = 0; i < parsedAssets.length; i++) {
        const asset = parsedAssets[i];
        try {
          const res = await window.authenticatedFetch('api/v1/assets', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(asset)
          });
          if (res.ok) success++;
          else failed++;
        } catch (e) {
          failed++;
        }
        const percent = Math.round(((i + 1) / parsedAssets.length) * 100);
        progressBar.style.width = `${percent}%`;
      }
  
      statusDiv.innerHTML = `
        <div class="alert alert-success py-2 small mb-0">
          <strong>Done!</strong><br>
          ${success} imported successfully<br>
          ${failed > 0 ? `${failed} failed` : ''}
        </div>`;
  
      if (window.refreshAssets) await window.refreshAssets();
      window.dispatchEvent(new CustomEvent('assets-updated'));
  
      setTimeout(() => {
        const modalEl = document.getElementById('newAssetModal');
        const modal = bootstrap.Modal.getInstance(modalEl);
        if (modal) modal.hide();
  
        batchSection.classList.add('d-none');
        createBtn.classList.remove('d-none');
        batchCreateBtn.classList.add('d-none');
        textarea.value = '';
        statusDiv.innerHTML = '';
        progressContainer.classList.add('d-none');
        batchCreateBtn.disabled = false;
        parsedAssets = [];
      }, 1800);
    });
  }